/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TrainerRouteImport } from './routes/trainer'
import { Route as TermosUtilizacaoRouteImport } from './routes/termos-utilizacao'
import { Route as StudentAreaRouteImport } from './routes/student-area'
import { Route as ScheduleRouteImport } from './routes/schedule'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as RedefinirSenhaRouteImport } from './routes/redefinir-senha'
import { Route as ProgramsRouteImport } from './routes/programs'
import { Route as ProfessorRouteImport } from './routes/professor'
import { Route as PoliticaPrivacidadeRouteImport } from './routes/politica-privacidade'
import { Route as PoliticaCookiesRouteImport } from './routes/politica-cookies'
import { Route as PlansRouteImport } from './routes/plans'
import { Route as LoginRouteImport } from './routes/login'
import { Route as EsqueciSenhaRouteImport } from './routes/esqueci-senha'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProgramasMmaRouteImport } from './routes/programas.mma'
import { Route as ProgramasJiuJitsuRouteImport } from './routes/programas.jiu-jitsu'
import { Route as ProgramasCapoeiraRouteImport } from './routes/programas.capoeira'
import { Route as ProgramasBoxeKickboxingRouteImport } from './routes/programas.boxe-kickboxing'
import { Route as MembershipSuccessRouteImport } from './routes/membership/success'
import { Route as MembershipMembershipIdRouteImport } from './routes/membership/$membershipId'
import { Route as CheckoutPlanIdRouteImport } from './routes/checkout/$planId'
import { Route as MembershipMembershipIdFormRouteImport } from './routes/membership/$membershipId/form'

const TrainerRoute = TrainerRouteImport.update({
  id: '/trainer',
  path: '/trainer',
  getParentRoute: () => rootRouteImport,
} as any)
const TermosUtilizacaoRoute = TermosUtilizacaoRouteImport.update({
  id: '/termos-utilizacao',
  path: '/termos-utilizacao',
  getParentRoute: () => rootRouteImport,
} as any)
const StudentAreaRoute = StudentAreaRouteImport.update({
  id: '/student-area',
  path: '/student-area',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduleRoute = ScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const RedefinirSenhaRoute = RedefinirSenhaRouteImport.update({
  id: '/redefinir-senha',
  path: '/redefinir-senha',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramsRoute = ProgramsRouteImport.update({
  id: '/programs',
  path: '/programs',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfessorRoute = ProfessorRouteImport.update({
  id: '/professor',
  path: '/professor',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliticaPrivacidadeRoute = PoliticaPrivacidadeRouteImport.update({
  id: '/politica-privacidade',
  path: '/politica-privacidade',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliticaCookiesRoute = PoliticaCookiesRouteImport.update({
  id: '/politica-cookies',
  path: '/politica-cookies',
  getParentRoute: () => rootRouteImport,
} as any)
const PlansRoute = PlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const EsqueciSenhaRoute = EsqueciSenhaRouteImport.update({
  id: '/esqueci-senha',
  path: '/esqueci-senha',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramasMmaRoute = ProgramasMmaRouteImport.update({
  id: '/programas/mma',
  path: '/programas/mma',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramasJiuJitsuRoute = ProgramasJiuJitsuRouteImport.update({
  id: '/programas/jiu-jitsu',
  path: '/programas/jiu-jitsu',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramasCapoeiraRoute = ProgramasCapoeiraRouteImport.update({
  id: '/programas/capoeira',
  path: '/programas/capoeira',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramasBoxeKickboxingRoute = ProgramasBoxeKickboxingRouteImport.update({
  id: '/programas/boxe-kickboxing',
  path: '/programas/boxe-kickboxing',
  getParentRoute: () => rootRouteImport,
} as any)
const MembershipSuccessRoute = MembershipSuccessRouteImport.update({
  id: '/membership/success',
  path: '/membership/success',
  getParentRoute: () => rootRouteImport,
} as any)
const MembershipMembershipIdRoute = MembershipMembershipIdRouteImport.update({
  id: '/membership/$membershipId',
  path: '/membership/$membershipId',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutPlanIdRoute = CheckoutPlanIdRouteImport.update({
  id: '/checkout/$planId',
  path: '/checkout/$planId',
  getParentRoute: () => rootRouteImport,
} as any)
const MembershipMembershipIdFormRoute =
  MembershipMembershipIdFormRouteImport.update({
    id: '/form',
    path: '/form',
    getParentRoute: () => MembershipMembershipIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRoute
  '/contact': typeof ContactRoute
  '/esqueci-senha': typeof EsqueciSenhaRoute
  '/login': typeof LoginRoute
  '/plans': typeof PlansRoute
  '/politica-cookies': typeof PoliticaCookiesRoute
  '/politica-privacidade': typeof PoliticaPrivacidadeRoute
  '/professor': typeof ProfessorRoute
  '/programs': typeof ProgramsRoute
  '/redefinir-senha': typeof RedefinirSenhaRoute
  '/register': typeof RegisterRoute
  '/schedule': typeof ScheduleRoute
  '/student-area': typeof StudentAreaRoute
  '/termos-utilizacao': typeof TermosUtilizacaoRoute
  '/trainer': typeof TrainerRoute
  '/checkout/$planId': typeof CheckoutPlanIdRoute
  '/membership/$membershipId': typeof MembershipMembershipIdRouteWithChildren
  '/membership/success': typeof MembershipSuccessRoute
  '/programas/boxe-kickboxing': typeof ProgramasBoxeKickboxingRoute
  '/programas/capoeira': typeof ProgramasCapoeiraRoute
  '/programas/jiu-jitsu': typeof ProgramasJiuJitsuRoute
  '/programas/mma': typeof ProgramasMmaRoute
  '/membership/$membershipId/form': typeof MembershipMembershipIdFormRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRoute
  '/contact': typeof ContactRoute
  '/esqueci-senha': typeof EsqueciSenhaRoute
  '/login': typeof LoginRoute
  '/plans': typeof PlansRoute
  '/politica-cookies': typeof PoliticaCookiesRoute
  '/politica-privacidade': typeof PoliticaPrivacidadeRoute
  '/professor': typeof ProfessorRoute
  '/programs': typeof ProgramsRoute
  '/redefinir-senha': typeof RedefinirSenhaRoute
  '/register': typeof RegisterRoute
  '/schedule': typeof ScheduleRoute
  '/student-area': typeof StudentAreaRoute
  '/termos-utilizacao': typeof TermosUtilizacaoRoute
  '/trainer': typeof TrainerRoute
  '/checkout/$planId': typeof CheckoutPlanIdRoute
  '/membership/$membershipId': typeof MembershipMembershipIdRouteWithChildren
  '/membership/success': typeof MembershipSuccessRoute
  '/programas/boxe-kickboxing': typeof ProgramasBoxeKickboxingRoute
  '/programas/capoeira': typeof ProgramasCapoeiraRoute
  '/programas/jiu-jitsu': typeof ProgramasJiuJitsuRoute
  '/programas/mma': typeof ProgramasMmaRoute
  '/membership/$membershipId/form': typeof MembershipMembershipIdFormRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRoute
  '/contact': typeof ContactRoute
  '/esqueci-senha': typeof EsqueciSenhaRoute
  '/login': typeof LoginRoute
  '/plans': typeof PlansRoute
  '/politica-cookies': typeof PoliticaCookiesRoute
  '/politica-privacidade': typeof PoliticaPrivacidadeRoute
  '/professor': typeof ProfessorRoute
  '/programs': typeof ProgramsRoute
  '/redefinir-senha': typeof RedefinirSenhaRoute
  '/register': typeof RegisterRoute
  '/schedule': typeof ScheduleRoute
  '/student-area': typeof StudentAreaRoute
  '/termos-utilizacao': typeof TermosUtilizacaoRoute
  '/trainer': typeof TrainerRoute
  '/checkout/$planId': typeof CheckoutPlanIdRoute
  '/membership/$membershipId': typeof MembershipMembershipIdRouteWithChildren
  '/membership/success': typeof MembershipSuccessRoute
  '/programas/boxe-kickboxing': typeof ProgramasBoxeKickboxingRoute
  '/programas/capoeira': typeof ProgramasCapoeiraRoute
  '/programas/jiu-jitsu': typeof ProgramasJiuJitsuRoute
  '/programas/mma': typeof ProgramasMmaRoute
  '/membership/$membershipId/form': typeof MembershipMembershipIdFormRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/admin'
    | '/contact'
    | '/esqueci-senha'
    | '/login'
    | '/plans'
    | '/politica-cookies'
    | '/politica-privacidade'
    | '/professor'
    | '/programs'
    | '/redefinir-senha'
    | '/register'
    | '/schedule'
    | '/student-area'
    | '/termos-utilizacao'
    | '/trainer'
    | '/checkout/$planId'
    | '/membership/$membershipId'
    | '/membership/success'
    | '/programas/boxe-kickboxing'
    | '/programas/capoeira'
    | '/programas/jiu-jitsu'
    | '/programas/mma'
    | '/membership/$membershipId/form'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/admin'
    | '/contact'
    | '/esqueci-senha'
    | '/login'
    | '/plans'
    | '/politica-cookies'
    | '/politica-privacidade'
    | '/professor'
    | '/programs'
    | '/redefinir-senha'
    | '/register'
    | '/schedule'
    | '/student-area'
    | '/termos-utilizacao'
    | '/trainer'
    | '/checkout/$planId'
    | '/membership/$membershipId'
    | '/membership/success'
    | '/programas/boxe-kickboxing'
    | '/programas/capoeira'
    | '/programas/jiu-jitsu'
    | '/programas/mma'
    | '/membership/$membershipId/form'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/admin'
    | '/contact'
    | '/esqueci-senha'
    | '/login'
    | '/plans'
    | '/politica-cookies'
    | '/politica-privacidade'
    | '/professor'
    | '/programs'
    | '/redefinir-senha'
    | '/register'
    | '/schedule'
    | '/student-area'
    | '/termos-utilizacao'
    | '/trainer'
    | '/checkout/$planId'
    | '/membership/$membershipId'
    | '/membership/success'
    | '/programas/boxe-kickboxing'
    | '/programas/capoeira'
    | '/programas/jiu-jitsu'
    | '/programas/mma'
    | '/membership/$membershipId/form'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AdminRoute: typeof AdminRoute
  ContactRoute: typeof ContactRoute
  EsqueciSenhaRoute: typeof EsqueciSenhaRoute
  LoginRoute: typeof LoginRoute
  PlansRoute: typeof PlansRoute
  PoliticaCookiesRoute: typeof PoliticaCookiesRoute
  PoliticaPrivacidadeRoute: typeof PoliticaPrivacidadeRoute
  ProfessorRoute: typeof ProfessorRoute
  ProgramsRoute: typeof ProgramsRoute
  RedefinirSenhaRoute: typeof RedefinirSenhaRoute
  RegisterRoute: typeof RegisterRoute
  ScheduleRoute: typeof ScheduleRoute
  StudentAreaRoute: typeof StudentAreaRoute
  TermosUtilizacaoRoute: typeof TermosUtilizacaoRoute
  TrainerRoute: typeof TrainerRoute
  CheckoutPlanIdRoute: typeof CheckoutPlanIdRoute
  MembershipMembershipIdRoute: typeof MembershipMembershipIdRouteWithChildren
  MembershipSuccessRoute: typeof MembershipSuccessRoute
  ProgramasBoxeKickboxingRoute: typeof ProgramasBoxeKickboxingRoute
  ProgramasCapoeiraRoute: typeof ProgramasCapoeiraRoute
  ProgramasJiuJitsuRoute: typeof ProgramasJiuJitsuRoute
  ProgramasMmaRoute: typeof ProgramasMmaRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/trainer': {
      id: '/trainer'
      path: '/trainer'
      fullPath: '/trainer'
      preLoaderRoute: typeof TrainerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/termos-utilizacao': {
      id: '/termos-utilizacao'
      path: '/termos-utilizacao'
      fullPath: '/termos-utilizacao'
      preLoaderRoute: typeof TermosUtilizacaoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/student-area': {
      id: '/student-area'
      path: '/student-area'
      fullPath: '/student-area'
      preLoaderRoute: typeof StudentAreaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule': {
      id: '/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof ScheduleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/redefinir-senha': {
      id: '/redefinir-senha'
      path: '/redefinir-senha'
      fullPath: '/redefinir-senha'
      preLoaderRoute: typeof RedefinirSenhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/programs': {
      id: '/programs'
      path: '/programs'
      fullPath: '/programs'
      preLoaderRoute: typeof ProgramsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/professor': {
      id: '/professor'
      path: '/professor'
      fullPath: '/professor'
      preLoaderRoute: typeof ProfessorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/politica-privacidade': {
      id: '/politica-privacidade'
      path: '/politica-privacidade'
      fullPath: '/politica-privacidade'
      preLoaderRoute: typeof PoliticaPrivacidadeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/politica-cookies': {
      id: '/politica-cookies'
      path: '/politica-cookies'
      fullPath: '/politica-cookies'
      preLoaderRoute: typeof PoliticaCookiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plans': {
      id: '/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof PlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/esqueci-senha': {
      id: '/esqueci-senha'
      path: '/esqueci-senha'
      fullPath: '/esqueci-senha'
      preLoaderRoute: typeof EsqueciSenhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/programas/mma': {
      id: '/programas/mma'
      path: '/programas/mma'
      fullPath: '/programas/mma'
      preLoaderRoute: typeof ProgramasMmaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/programas/jiu-jitsu': {
      id: '/programas/jiu-jitsu'
      path: '/programas/jiu-jitsu'
      fullPath: '/programas/jiu-jitsu'
      preLoaderRoute: typeof ProgramasJiuJitsuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/programas/capoeira': {
      id: '/programas/capoeira'
      path: '/programas/capoeira'
      fullPath: '/programas/capoeira'
      preLoaderRoute: typeof ProgramasCapoeiraRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/programas/boxe-kickboxing': {
      id: '/programas/boxe-kickboxing'
      path: '/programas/boxe-kickboxing'
      fullPath: '/programas/boxe-kickboxing'
      preLoaderRoute: typeof ProgramasBoxeKickboxingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/membership/success': {
      id: '/membership/success'
      path: '/membership/success'
      fullPath: '/membership/success'
      preLoaderRoute: typeof MembershipSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/membership/$membershipId': {
      id: '/membership/$membershipId'
      path: '/membership/$membershipId'
      fullPath: '/membership/$membershipId'
      preLoaderRoute: typeof MembershipMembershipIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/$planId': {
      id: '/checkout/$planId'
      path: '/checkout/$planId'
      fullPath: '/checkout/$planId'
      preLoaderRoute: typeof CheckoutPlanIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/membership/$membershipId/form': {
      id: '/membership/$membershipId/form'
      path: '/form'
      fullPath: '/membership/$membershipId/form'
      preLoaderRoute: typeof MembershipMembershipIdFormRouteImport
      parentRoute: typeof MembershipMembershipIdRoute
    }
  }
}

interface MembershipMembershipIdRouteChildren {
  MembershipMembershipIdFormRoute: typeof MembershipMembershipIdFormRoute
}

const MembershipMembershipIdRouteChildren: MembershipMembershipIdRouteChildren =
  {
    MembershipMembershipIdFormRoute: MembershipMembershipIdFormRoute,
  }

const MembershipMembershipIdRouteWithChildren =
  MembershipMembershipIdRoute._addFileChildren(
    MembershipMembershipIdRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AdminRoute: AdminRoute,
  ContactRoute: ContactRoute,
  EsqueciSenhaRoute: EsqueciSenhaRoute,
  LoginRoute: LoginRoute,
  PlansRoute: PlansRoute,
  PoliticaCookiesRoute: PoliticaCookiesRoute,
  PoliticaPrivacidadeRoute: PoliticaPrivacidadeRoute,
  ProfessorRoute: ProfessorRoute,
  ProgramsRoute: ProgramsRoute,
  RedefinirSenhaRoute: RedefinirSenhaRoute,
  RegisterRoute: RegisterRoute,
  ScheduleRoute: ScheduleRoute,
  StudentAreaRoute: StudentAreaRoute,
  TermosUtilizacaoRoute: TermosUtilizacaoRoute,
  TrainerRoute: TrainerRoute,
  CheckoutPlanIdRoute: CheckoutPlanIdRoute,
  MembershipMembershipIdRoute: MembershipMembershipIdRouteWithChildren,
  MembershipSuccessRoute: MembershipSuccessRoute,
  ProgramasBoxeKickboxingRoute: ProgramasBoxeKickboxingRoute,
  ProgramasCapoeiraRoute: ProgramasCapoeiraRoute,
  ProgramasJiuJitsuRoute: ProgramasJiuJitsuRoute,
  ProgramasMmaRoute: ProgramasMmaRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
